// Promise-based confirm dialog: callers await confirmRemoveFromPicker(name);
// the dialog UI is rendered once at the app root and reads `pending`.

import Vue from 'vue'

export type ConfirmRequest = {
  slideName: string
  resolve: (confirmed: boolean) => void
}

export const confirmStore = Vue.observable({
  pending: null as ConfirmRequest | null,
})

export function confirmRemoveFromPicker(slideName: string): Promise<boolean> {
  return new Promise((resolve) => {
    // If a previous prompt is still open, treat it as cancelled so we
    // never leak a hanging promise.
    if (confirmStore.pending) confirmStore.pending.resolve(false)
    confirmStore.pending = { slideName, resolve }
  })
}

export function resolveConfirm(confirmed: boolean): void {
  if (!confirmStore.pending) return
  const { resolve } = confirmStore.pending
  confirmStore.pending = null
  resolve(confirmed)
}
